import React, { useState } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import { Autocomplete, Box, Switch } from '@mui/material'
import { useActivities } from '../store'
import { workflowService } from '../../../../services/admin/workflow'
import { useAuthContext } from '../../../../hooks/useAuthContext'
import { ACTIVITY_TYPES } from '../../../../utility/constants'
import { alpha, styled } from '@mui/material/styles'
import DialogWrapper from '../../../../components/core-ui/DialogWrapper'
import { colors } from '../../../../theme/colors'
import { textFieldStyle } from '../../components/CreateProcessTemplateDialog'

const PinkSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: colors.button,
    '&:hover': {
      backgroundColor: alpha(colors.button, theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: colors.button,
  },
}))

const label = { inputProps: { 'aria-label': 'Color switch demo' } }

const activityTypes = [
  { label: 'Data Entry', value: ACTIVITY_TYPES.DATA_ENTRY },
  { label: 'Review', value: ACTIVITY_TYPES.REVIEW },
  { label: 'Long Running', value: ACTIVITY_TYPES.LONG_RUNNING },
  { label: 'End Accepted', value: ACTIVITY_TYPES.END_ACCEPTED },
  { label: 'End Rejected', value: ACTIVITY_TYPES.END_REJECTED },
  { label: 'Committee Data Entry', value: ACTIVITY_TYPES.COMMITTEE_DATA_ENTRY },
  { label: 'Committee Review', value: ACTIVITY_TYPES.COMMITTEE_REVIEW },
  { label: 'Parallel Start', value: ACTIVITY_TYPES.PARALLEL_START },
  { label: 'Parallel End', value: ACTIVITY_TYPES.PARALLEL_END },
]

const CreateActivityTemplateDialog = ({ show, setShow, processTemplateId }) => {
  const { user } = useAuthContext()
  const addActivity = useActivities((state) => state.addActivity)
  const setActivities = useActivities((state) => state.setActivities)
  const activities = useActivities((state) => state.activities)
  const [activityTemplate, setActivityTemplate] = useState({
    activity_type: { label: 'Data Entry', value: ACTIVITY_TYPES.DATA_ENTRY },
    is_start: false,
    activity_template_name: '',
    description: '',
  })

  const onSave = async () => {
    // save to database
    const initialDetails = {
      activity_type: activityTemplate?.activity_type?.value,
      activity_template_name: activityTemplate?.activity_template_name,
      description: activityTemplate?.description,
      user_id: user?.id,
      process_template_id: processTemplateId,
      is_start: activityTemplate?.is_start,
      color_code: '#8989ff',
      is_assigned_to_initiator: false,
      is_delegatable: false,
      is_dynamic_assignment: false,
      rank: activities?.length + 1,
    }

    const newActivity = await workflowService.createActivityTemplate(user, initialDetails)

    // update the local routes
    if (initialDetails.is_start) {
      const updated = activities.map((it) => (it.is_start ? { ...it, is_start: false } : it))
      setActivities([...updated, newActivity.data])
    } else {
      addActivity(newActivity.data)
    }

    // initialize create activity details
    setActivityTemplate({
      activity_type: { label: 'Data Entry', value: ACTIVITY_TYPES.DATA_ENTRY },
      is_start: false,
      activity_template_name: '',
      description: '',
    })
    // finally hide dialog
    setShow(false)
  }

  return (
    <DialogWrapper
      heading={'Create Activity Template'}
      open={show}
      onClose={() => setShow(false)}
      actions={null}
    >
      <TextField
        size="small"
        style={{ margin: '8px 0px' }}
        id="outlined"
        label="Activity Name"
        placeholder="Activity Name"
        sx={{ ...textFieldStyle, width: '100%' }}
        onChange={(e) => {
          setActivityTemplate({ ...activityTemplate, activity_template_name: e.target.value })
        }}
        value={activityTemplate.activity_template_name}
      />
      <TextField
        size="small"
        style={{ margin: '8px 0px' }}
        id="outlined"
        label="Description"
        placeholder="Description"
        sx={{ ...textFieldStyle, width: '100%' }}
        multiline
        onChange={(e) => {
          setActivityTemplate({ ...activityTemplate, description: e.target.value })
        }}
        value={activityTemplate?.description}
      />
      <Autocomplete
        size="small"
        style={{ margin: '8px 0px' }}
        id="activity-type"
        options={activityTypes}
        sx={{ ...textFieldStyle, width: '100%' }}
        value={activityTemplate?.activity_type}
        defaultValue={activityTypes[1]}
        onChange={(e, v) => {
          if (v) {
            setActivityTemplate({ ...activityTemplate, activity_type: v })
          }
        }}
        renderInput={(params) => (
          <TextField {...params} label="Activity Type" placeholder="Activity Type" />
        )}
      />
      <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <p>Is start activity?</p>
        <PinkSwitch
          {...label}
          value={activityTemplate?.is_start}
          onChange={(e) => {
            setActivityTemplate({ ...activityTemplate, is_start: e.target.checked })
          }}
        />
      </Box>
      <Box style={{ marginTop: 24, display: 'flex', justifyContent: 'flex-end', columnGap: 16 }}>
        <Button variant="contained" onClick={() => setShow(false)}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={onSave}>
          Save
        </Button>
      </Box>
    </DialogWrapper>
  )
}

export default CreateActivityTemplateDialog
